import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44381f19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "right-model",
  ref: "rightModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "form-content" }
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("权限尚未配置，请先配置权限 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "operation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_authority = _resolveComponent("authority")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      getContainer: () => _ctx.$refs.rightModel,
      title: `权限配置（角色：${_ctx.roleType}）`,
      width: '10.6rem',
      footer: false,
      visible: _ctx.rightVisible,
      onCancel: _ctx.handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.rightVisible)
            ? (_openBlock(), _createBlock(_component_authority, {
                key: 0,
                ref: "rightInfolRef",
                requestType: 'role',
                showTicketConfig: true,
                roleData: _ctx.roleData,
                onCheckedTerminal: _ctx.checkedTerminal
              }, null, 8, ["roleData", "onCheckedTerminal"]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_7, 512), [
          [_vShow, _ctx.selectTerminalTip]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancle && _ctx.handleCancle(...args)))
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
          }, "确定")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "title", "width", "visible", "onCancel"])
  ], 512))
}